/* eslint-disable */
/**
 * 树型结构的数据处理面像对象的法方法封装
 * @param JsonTree
 * @param options
 * @constructor
 */

function CreateTree(JsonTree, options) {
  /**
   * attributes : JsonArrTree
   *
   * options Object
   * {
   *  JsonData 树结构资源数据
   *  rootId 根节点
   *  parentId 要比较的父节点
   *  childrenId 要比较的节点
   * }
   *
   */
  this.JsonArrTree = JsonTree
  // this.JsonData = JsonData
  // this.rootId = rootId
  // this.parentId = parentId
  // this.childrenId = childrenId
  CreateTree.init.call(this, options)
  this.newTreeData = [
  ]
  this.initItemTree = []
  if (this.JsonArrTree && this.JsonData.length > 0) {
    this.initTree()
  }
}
CreateTree.init = function(object) {
  for (let t in object) {
    this[t] = object[t]
  }
}
CreateTree.prototype = {
  constructor: CreateTree,
  creatTre: function() {
    for (let i = 0; i < this.JsonData.length; i++) {
      if (this.JsonData[i][this.parentId] === this.rootId) {
        this.newTreeData.push(this.eachMap(i))
        this.JsonData.splice(i, 1)
        i--
      }
    }
    // if(this.newTreeData.length === 0 && (this.rootId === null || this.rootId)) {
    //     this.newTreeData.push(this.eachMap(0, this.rootId))
    // }
    this.runTree(this.newTreeData)
    return this.newTreeData
  },
  runTree: function(newTree) {
    if (this.JsonData.length !== 0) {
      for (let i = 0; i < newTree.length; i++) {
        for (let j = 0; j < this.JsonData.length; j++) {
          if (newTree[i][this.childrenId] === this.JsonData[j][this.parentId]) {
            if (!newTree[i].children) {
              newTree[i].children = []
            }
            newTree[i].children.push(this.eachMap(j))
            this.JsonData.splice(j, 1)
            j--
          }
        }
        if (newTree[i].children) {
          this.runTree.call(this, newTree[i].children)
        }
      }
    }
  },
  eachMap: function(index, rootValue) {
    let options = {}
    for (let k in this.initItemTree) {
      options[k] = this.initItemTree[k](index, rootValue)
    }
    return options
  },
  initTree: function() {
    for (let t in this.JsonArrTree) {
      this.initItemTree[t] = (index, rootvalue) => {
        if (rootvalue) {
          if (t === this.parentId) {
            return rootvalue
          } else if (t === this.childrenId) {
            return rootvalue
          } else {
            return 'root'
          }
        } else {
          return this.JsonData[index][this.JsonArrTree[t]]
        }
      }
    }
  }
}
function ExportExcels() { // 二进制流文件下载
  this.blobUrl = ''
  this.blobData = {}

}

/**
 *
 *二进制文件处理方法
 */
 ExportExcels.prototype = {
  getBlob: function(data, names, callback) {
    let newblob = data.slice(0, 1) // new Blob([data])
    let reader = new FileReader()
    reader.readAsDataURL(newblob)
    reader.onload = function(evt) {
      if (evt.target.readyState === FileReader.DONE) {
        newblob = data.slice(0, data.size)
        window.URL = window.URL || window.webkitURL
        if ('msSaveOrOpenBlob' in navigator) {
          window.navigator.msSaveOrOpenBlob(newblob, names)
        } else {
          this.blobUrl = window.URL.createObjectURL(newblob)
          let link = document.createElement('a')
          link.download = names
          link.href = this.blobUrl
          let o = document.body
          o.appendChild(link).click()
          $(link).remove()
          if (callback && typeof callback === 'function') {
            callback({ blobUrl: this.blobUrl, dataBlob: this.blobData })
          }
        }
      }
    }

  },
  download: function(args) {
    /*
      {
            $this: vue的实例指针this,
            blobFiles: blob 流文件
            fileName: name 文件名
            sucessDown: fn 成功回调
            errDown: fn  失败回调
      }
     */
    this.blobData = args.blobFiles
    if (this.blobData.headers.message || this.blobData.data.size <= 0) {
      if (args.errDown && typeof args.errDown === 'function') {
        args.errDown(this.blobData)
      } else {
        args.$this.$notify({
          title: '提示',
          type: 'error',
          message: this.blobData.headers.message
            ? decodeURIComponent(this.blobData.headers.message)
            : '暂无数据下载'
        })
      }
    } else {
      const  sucessDown = args.sucessDown ? args.sucessDown : null
      this.getBlob(this.blobData.data, args.fileName, sucessDown)
    }
  }
}
/**
 *
 * 路由转换
 *
 */
function ConversionRouting(routeData) {
    this.routeData = routeData
    this.newDocMenu = process.env.NODE_ENV === 'development' ? this.initRout(this.routeData).filter(it => it.path !== '/') : []
    this.constRouter = process.env.NODE_ENV === 'development' ? this.initRout(this.routeData) : (this.initRout(this.routeData).find(it => it.path === '/') ? [this.initRout(this.routeData).find(it => it.path === '/')] : [])
    this.filterRouter = this.filterConstRoter(this.constRouter)
    this.homeMenu = (this.initRout(this.routeData).length && this.initRout(this.routeData).find(it => it.path === '/')) ? [this.initRout(this.routeData).find(it => it.path === '/')] : []
    // 动态路由加载
    this.homeRoute = (this.routeData.length && this.routeData.find(it => it.path === '/')) ? [this.routeData.find(it => it.path === '/')] : []
    this.DocRoutes =  process.env.NODE_ENV === 'development' ? this.routeData.filter(it => it.path !== '/') : []
}
ConversionRouting.prototype = {
  constructor: ConversionRouting,
  randomRange: function(min, max, charStr){
    /** 随机生成固定位数或者一定范围内的字符串数字组合
     * @param {Number} min 范围最小值
     * @param {Number} max 范围最大值，当不传递时表示生成指定位数的组合
     * @param {String} charStr指定的字符串中生成组合
     * @returns {String} 返回字符串结果
     *
     * */
  let returnStr = "", range;
  if(typeof min == 'undefined'){
    min = 10
  }
  if(typeof max == 'string'){
    charStr = max
  }
  range = ((max && typeof max == 'number') ? Math.round(Math.random() * (max-min)) + min : min)
  charStr = charStr || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for(let i=0; i < range; i++){
    let index = Math.round(Math.random() * (charStr.length-1))
    returnStr += charStr.substring(index, index+1)
  }
  return returnStr
 },
  filterConstRoter: function(data) {
  let menuList = []
  run(data, menuList)
  function run(data, menulist) {
    data.forEach(item => {
      if (item.children && item.children.length) {
        let { children, ...ptions } = item
        menulist.push(ptions)
        run(item.children, menulist)
      } else {
        menulist.push(item)
      }
    })
  }
  return menuList
  },
  initRout: function (RouteData) {
     return RouteData.map(item => {
          let options = {
            icon: (item.meta && item.meta.icon) ? item.meta.icon : '',
            menueffectivetag: 1,
            menuename: item.path.split('/')[ item.path.split('/').length -1],
            menuid: this.randomRange(14, 16),
            menupid: this.randomRange(6, 12),
            menutype: 1,
            path: item.path,
            tenantid: null,
            title: (item.meta && item.meta.title) ? item.meta.title : ''
          }
         if (item.children && item.children.length) {
              options.children = this.initRout(item.children)
           }
           return options
      })
   }
}

const copyToClip = content => {
  const input = document.createElement('input');
  input.setAttribute('value', content);
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
  // message.success(tipString);
};
// 获取随机字符串
export function getNoncestr() {
  let d = new Date().getTime();
  // eslint-disable-next-line func-names
  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function(c) {
    // eslint-disable-next-line no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/* eslint-enable */
/**
 * 获取远程文件的url 的最后一段
 */
function remoteFilename(url) {
  if (!url) return ''
  const segs = url.split('/')
  // 取后面的有效信息
  const name = segs[segs.length - 1].substring(32)
  return decodeURIComponent(decodeURIComponent(name))
}
 export function antdFile(url, originURL) {
  return {
    uid: getNoncestr(),
    name: remoteFilename(originURL),
    status: 'done',
    url,
    originURL
  }
}
// 原始地址转换为可预览的地址
function transPhoto(previewUrl, originUrl) {
  // previewUrl表示可预览的url,originUrl表示原始url
  const previewGroups = (previewUrl || '').split(',')
  const previewGroups_ = (originUrl || '')
    .split(',')
    .map((f, idx) => antdFile(previewGroups[idx], f))
  return previewGroups_[0]?.url
}

export default {
  transPhoto,
  DownExcelse: new ExportExcels(),
  CreateTree,
  CreatDocMenu: ConversionRouting,
  copyToClip
}
